import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "main",
      component: () => import("./views/Main.vue"),
      children: [
        {
          path: "/",
          name: 'home',
          component: () => import("./views/Home.vue")
        },
        {
          path: "/accinfo",
          name: "accinfo",
          component: () => import("./views/acc/AccInfo.vue")
        },
        {
          path: "/server",
          name: "server",
          component: () => import("./views/acc/Server.vue")
        },
        {
          path: "/work",
          name: "work",
          component: () => import("./views/acc/Work.vue")
        },
        {
          path: "/pay",
          name: "pay",
          component: () => import("./views/acc/Pay.vue")
        },
        {
          path: "/program",
          name: "program",
          component: () => import("./views/acc/Program.vue")
        },
        {
          path: "/basedata",
          name: "basedata",
          component: () => import("./views/BaseData.vue")
        },
        {
          path: "/project",
          name: "project",
          component: () => import("./views/fin/Project.vue")
        },
        {
          path: "/notice",
          name: "notice",
          component: () => import("./views/fin/Notice.vue")
        },
        {
          path: "/contract",
          name: "contract",
          component: () => import("./views/fin/Contract.vue")
        },
        {
          path: "/contract/:id",
          name: "contract",
          component: () => import("./views/fin/Contract.vue")
        },
        {
          path: "/record",
          name: "record",
          component: () => import("./views/fin/Record.vue")
        },
        {
          path: "/navigation",
          name: "navigation",
          component: () => import("./views/sys/Navigation.vue")
        },
        {
          path: "/role",
          name: "role",
          component: () => import("./views/sys/Role.vue")
        },
        {
          path: "/account",
          name: "account",
          component: () => import("./views/sys/Account.vue")
        },
        {
          path: "/siteconfig",
          name: "siteconfig",
          component: () => import("./views/sys/SiteConfig.vue")
        },
        {
          path: "/sallary",
          name: "sallary",
          component: () => import("./views/fin/Sallary.vue")
        },
        {
          path: "/customer",
          name: "customer",
          component: () => import("./views/crm/Customer.vue")
        },
        {
          path: "/customer/:state",
          name: "customer",
          component: () => import("./views/crm/Customer.vue")
        },
        {
          path: "/follow",
          name: "follow",
          component: () => import("./views/crm/Follow.vue")
        },
        {
          path: "/follow/:id",
          name: "followid",
          component: () => import("./views/crm/Follow.vue")
        },
        {
          path: "/crmpreview",
          name: "crmpreview",
          component: () => import("./views/crm/Preview.vue")
        },
        {
          path: "/cdn",
          name: "cdn",
          component: () => import("./views/cdn/Cdn.vue")
        },
        {
          path: "/link",
          name: "link",
          component: () => import("./views/cdn/Link.vue")
        },
        {
          path: "/daily",
          name: "daily",
          component: () => import("./views/cdn/Daily.vue")
        },
        {
          path: "/achievement",
          name: "achievement",
          component: () => import("./views/fin/Achievement.vue")
        },
        //新增模块--打卡管理--请假管理
        {
          path: "/askrecord",
          name: "askrecord",
          component: () => import("./views/att/AskRecord.vue")
        },
        {
          path: "/clockrecord",
          name: "clockrecord",
          component: () => import("./views/att/ClockRecord.vue")
        },
      ]
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./views/Login.vue")
    },
  ]
});
